import { api, authHeader } from "../configs/axiosConfigs";

const unwrap = (response) => response?.data;

const SmsReportsApiService = {
  getSmsReport: async (searchParams) => {
    const response = await api.request({
      url: "/SLN/Management/SmsReports/GetSmsReport",
      method: "POST",
      headers: authHeader(),
      data: searchParams,
    });
    return unwrap(response);
  },

  getMonitoringSummary: async (searchParams) => {
    const response = await api.request({
      url: "/SLN/Management/SmsReports/GetMonitoringSummary",
      method: "POST",
      headers: authHeader(),
      data: searchParams,
    });
    return unwrap(response);
  },

  getStatistics: async (startDate = null, endDate = null) => {
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);

    const response = await api.request({
      url: `/SLN/Management/SmsReports/GetStatistics?${params.toString()}`,
      method: "GET",
      headers: authHeader(),
    });
    return unwrap(response);
  },

  getSmsDetail: async (id) => {
    const response = await api.request({
      url: `/SLN/Management/SmsReports/GetSmsDetail?id=${id}`,
      method: "GET",
      headers: authHeader(),
    });
    return unwrap(response);
  },

  getMySmsHistory: async (pageNumber = 1, pageSize = 20) => {
    const params = new URLSearchParams();
    params.append("pageNumber", pageNumber.toString());
    params.append("pageSize", pageSize.toString());

    const response = await api.request({
      url: `/SLN/Management/SmsReports/GetMySmsHistory?${params.toString()}`,
      method: "GET",
      headers: authHeader(),
    });
    return unwrap(response);
  },

  syncDeliveryStatuses: async (maxItems = 100) => {
    const response = await api.request({
      url: `/SLN/Management/SmsReports/SyncDeliveryStatuses?maxItems=${maxItems}`,
      method: "POST",
      headers: authHeader(),
    });
    return unwrap(response);
  },

  refreshSmsStatus: async (id) => {
    const response = await api.request({
      url: `/SLN/Management/SmsReports/RefreshSmsStatus?id=${id}`,
      method: "POST",
      headers: authHeader(),
    });
    return unwrap(response);
  },

  retrySms: async (id) => {
    const response = await api.request({
      url: `/SLN/Management/SmsReports/RetrySms?id=${id}`,
      method: "POST",
      headers: authHeader(),
    });
    return unwrap(response);
  },

  getSmsTypes: async () => {
    const response = await api.request({
      url: "/SLN/Management/SmsReports/GetSmsTypes",
      method: "GET",
      headers: authHeader(),
    });
    return unwrap(response);
  },

  exportExcel: async (searchParams) => {
    const response = await api.request({
      url: "/SLN/Management/SmsReports/ExportExcel",
      method: "POST",
      headers: authHeader(),
      data: searchParams,
    });
    return unwrap(response);
  },

  exportPdf: async (searchParams) => {
    const response = await api.request({
      url: "/SLN/Management/SmsReports/ExportPdf",
      method: "POST",
      headers: authHeader(),
      data: searchParams,
    });
    return unwrap(response);
  },
};

export default SmsReportsApiService;
